"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteredChatMessagesContext = void 0;
const react_1 = require("react");
exports.FilteredChatMessagesContext = (0, react_1.createContext)({});
